import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "introduce-cleric",
    "stage": {
        "image": require("./image.png"),
        "imageOffset": {"x": -6, "y": -1},
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "width": 18,
            "height": 10,
        }),
        "text": function(stage) {
            return "Defend your camp."
        },
        "conditions": convertOldChapterScripting({
            "0:start": [
                {
                    "type": "MoveUnit",
                    "position": {"x": 1, "y": 7},
                    "classKey": "#B",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 3, "y": 0},
                    "classKey": "#A",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 5, "y": 7},
                    "classKey": "#C",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 4, "y": 7},
                    "classKey": "#C",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 4, "y": 6},
                    "classKey": "#C",
                },
                {"type": "Wait", "time": 1},
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "brigid",
                        "text": "Uh oh.",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "brigid",
                        "text": "They have us surrounded.",
                        "expression": "frowny"
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "oriana",
                        "text": "We'll just fight our way out!",
                    }
                },
                {
                    "type": "StopDialogue",
                },
            ],
            "1:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#1",
                        "position": {"x": 3, "y": -1},
                        "classKey": "archer",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#2",
                        "position": {"x": 4, "y": -1},
                        "classKey": "berserker",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 3, "y": 0},
                    "classKey": "#1",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 4, "y": 0},
                    "classKey": "#2",
                }
            ],
            "3:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#3",
                        "position": {"x": 3, "y": 8},
                        "classKey": "berserker",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 3, "y": 7},
                    "classKey": "#3",
                },
            ],
            "4:start": [
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "???", "face": null,
                        "text": "Phew! Finally found you!",
                    }
                },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "position": {"x": 6, "y": 3},
                        "key": "callista",
                        "affiliation": "good",
                    }
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 5, "y": 3},
                    "classKey": "callista",
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 4, "y": 3},
                    "classKey": "callista",
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "callista",
                        "text": "What a messy battle.",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "callista",
                        "text": "Leave the healing to me!",
                    }
                },
                {
                    "type": "StopDialogue",
                },
            ],
        }, [
            {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
            {"type": "FinishLocation", "locationKey": "3"},
            {"type": "UnlockLocations", "routeKeys": ["6", "7", "8"], "locationKeys": ["4"]},
            {"type": "UnlockLocations", "routeKeys": ["B1", "B2", "B3"], "locationKeys": ["B"]},
        ])
    },
}

// // https://serenesforest.net/wp-content/uploads/2017/02/53.png
// "introduce-cleric": {
//     "music": "hero",
//     "hasPreparation": false,
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/rivers.png"),
//         "tiles": [
//             {"position": {"x": 1, "y": 2}, "passable": false},
//             {"position": {"x": 1, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 4}, "passable": false},
//             {"position": {"x": 1, "y": 5}, "passable": false},
//             {"position": {"x": 0, "y": 0}, "passable": false},
//             {"position": {"x": 0, "y": 1}, "passable": false},
//             {"position": {"x": 0, "y": 2}, "passable": false},
//             {"position": {"x": 0, "y": 3}, "passable": false},
//             {"position": {"x": 0, "y": 4}, "passable": false},
//             {"position": {"x": 0, "y": 5}, "passable": false},
//             {"position": {"x": 0, "y": 6}, "passable": false},
//             {"position": {"x": 3, "y": 2}, "passable": false},
//             {"position": {"x": 4, "y": 2}, "passable": false},
//             {"position": {"x": 5, "y": 2}, "passable": false},
//             {"position": {"x": 0, "y": 6}, "passable": false},
//             {"position": {"x": 3, "y": 5}, "passable": false},
//             {"position": {"x": 4, "y": 5}, "passable": false},
//             {"position": {"x": 5, "y": 5}, "passable": false},
//             {"position": {"x": 5, "y": 4}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/tent_blue.png")},
//             {"position": {"x": 5, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 0, "y": 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             {"position": {"x": 1, "y": 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 4, "y": 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 3, "y": 3}, "affiliation": "good"},
//         {"position": {"x": 3, "y": 4}, "affiliation": "good"},
//         // {"position": {x: 4, y: 3}, "affiliation": "good"},
//         // {"position": {x: 4, y: 4}, "affiliation": "good"},
//         {"position": {"x": 3, "y": -1}, "affiliation": "bad", "classKey": "berserker", "key": "#A"},
//         {"position": {"x": 2, "y": 8}, "affiliation": "bad", "classKey": "berserker", "key": "#B"},
//         {"position": {"x": 5, "y": 8}, "affiliation": "bad", "classKey": "archer", "key": "#C"},
//     ],
//     "events": {
//         "0:start": [
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 7},
//                 "classKey": "#B",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 3, "y": 0},
//                 "classKey": "#A",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 7},
//                 "classKey": "#C",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 4, "y": 7},
//                 "classKey": "#C",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 4, "y": 6},
//                 "classKey": "#C",
//             },
//             {"type": "Wait", "time": 1},
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "brigid",
//                     "text": "Uh oh.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "brigid",
//                     "text": "They have us surrounded.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana",
//                     "text": "We'll just fight our way out!",
//                 }
//             },
//             {
//                 "type": "StopDialogue",
//             },
//         ],
//         "1:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 3, "y": -1},
//                     "classKey": "archer",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#2",
//                     "position": {"x": 4, "y": -1},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 3, "y": 0},
//                 "classKey": "#1",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 4, "y": 0},
//                 "classKey": "#2",
//             }
//         ],
//         "3:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#3",
//                     "position": {"x": 3, "y": 8},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 3, "y": 7},
//                 "classKey": "#3",
//             },
//         ],
//         "4:start": [
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "???", "face": null,
//                     "text": "Phew! Finally found you!",
//                 }
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "position": {"x": 6, "y": 3},
//                     "key": "callista",
//                     "affiliation": "good",
//                 }
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 3},
//                 "classKey": "callista",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 4, "y": 3},
//                 "classKey": "callista",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "callista",
//                     "text": "What a messy battle.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "callista",
//                     "text": "Leave the healing to me!",
//                 }
//             },
//             {
//                 "type": "StopDialogue",
//             },
//         ],
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "3"},
//         {"type": "UnlockLocations", "routeKeys": ["6", "7", "8"], "locationKeys": ["4"]},
//         {"type": "UnlockLocations", "routeKeys": ["B1", "B2", "B3"], "locationKeys": ["B"]},
//     ],
//     "nextUrl": "/games/hero/chapters/upgrade-archer",
// },
